const millisecondsPerDay = 24 * 60 * 60 * 1000;

/**
 * Returns the number of calendar days remaining, including the expiry date.
 * API date-only values are parsed as UTC midnight, so both dates are compared
 * using UTC calendar days.
 */
export function getCalendarDaysRemaining(expiryDate: Date, now = new Date()): number {
  const expiryDay = Date.UTC(expiryDate.getUTCFullYear(), expiryDate.getUTCMonth(), expiryDate.getUTCDate());
  const currentDay = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());

  return (expiryDay - currentDay) / millisecondsPerDay + 1;
}
